/* Conseiller Rog (21/10/2026). Deux emplacements, même code :
   - data-rogc="page"  : page /pages/conseiller (titre, champ, fil des réponses, rappel) ;
   - data-rogc="fiche" : bloc question de la fiche produit, juste après la carte « Votre configuration » ;
     la question part avec la fiche et la configuration choisie, la réponse s'affiche sous le bloc, sans quitter la page.
   Pas de bulle flottante, pas de question préremplie. Configuration : <script type="application/json" data-rogc-config>
   dans chaque emplacement. Si config.demo est vrai (thème d'aperçu seulement), les réponses viennent de
   rog-conseiller-demo.js (MODE DÉMONSTRATION, jamais en production) ; sinon du programme Cloudflare « rog-conseiller ».
   La conversation reste dans l'onglet (sessionStorage).
   22/10/2026 (bloc de la fiche simplifié) : un seul point d'entrée, le champ et « Envoyer ». Après la première réponse,
   un bouton « Vous souhaitez parler à un conseiller ? » ouvre, dans le bloc, un petit formulaire (question + e-mail) :
   la demande part à contact@ par le circuit existant POST /rappel (canal e-mail), avec la configuration et la page.
   Le visiteur ne quitte jamais la fiche. */
(function () {
  "use strict";
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  // Texte du conseiller -> HTML sûr : paragraphes, listes « - », liens vers le site seulement.
  function rendre(texte) {
    var lignes = String(texte || "").split(/\n/), html = "", liste = false, para = [];
    function lien(s) {
      return esc(s).replace(/\[([^\]]+)\]\(((?:https:\/\/(?:www\.)?rogmotorsport\.com)?\/[^)\s]*)\)/g, function (_, t, u) {
        return '<a href="' + u.replace(/"/g, "") + '">' + t + "</a>";
      }).replace(/\[([^\]]+)\]\([^)]*\)/g, "$1");
    }
    function finPara() { if (para.length) { html += "<p>" + lien(para.join(" ")) + "</p>"; para = []; } }
    lignes.forEach(function (l) {
      var m = /^\s*[-•]\s+(.*)$/.exec(l);
      if (m) { finPara(); if (!liste) { html += "<ul>"; liste = true; } html += "<li>" + lien(m[1]) + "</li>"; return; }
      if (liste) { html += "</ul>"; liste = false; }
      finPara();
      if (l.trim()) para.push(l.trim());
    });
    finPara();
    if (liste) html += "</ul>";
    // typographie française : espace insécable avant ? ! : ;
    return html.replace(/ ([?!:;»])/g, "\u00a0$1").replace(/« /g, "«\u00a0").replace(/(\d) (%|€)/g, "$1\u00a0$2").replace(/(\d) (\d{3})(?!\d)/g, "$1\u00a0$2");
  }

  // Configuration lue dans la carte « Votre configuration » de la fiche (lignes du récapitulatif et total affiché).
  function lireConfiguration() {
    var dl = document.getElementById("rogx-recap-lignes"), lignes = [];
    if (dl) {
      dl.querySelectorAll("dt").forEach(function (dt) {
        var dd = dt.nextElementSibling;
        if (dd && dd.tagName === "DD") lignes.push(dt.textContent.trim() + " : " + dd.textContent.trim().replace(/\s+/g, " "));
      });
    }
    // prix payé : le prix de vente d'abord (le prix « regular » est le prix barré quand il y a une baisse)
    var total = document.querySelector('.rogx-config [id^="price-"] .price-item--sale') || document.querySelector('.rogx-config [id^="price-"] .price-item--regular');
    var barre = document.querySelector('.rogx-config [id^="price-"] .price-item--sale') && document.querySelector('.rogx-config [id^="price-"] .price-item--regular');
    if (total && total.textContent.trim()) lignes.push("Total : " + total.textContent.trim().replace(/\s+/g, " ") + (barre && barre.textContent.trim() ? " (au lieu de " + barre.textContent.trim().replace(/\s+/g, " ") + ")" : ""));
    return lignes.slice(0, 14).join("\n");
  }

  function demarrer(racine) {
    var cfgEl = racine.querySelector("script[data-rogc-config]");
    if (!cfgEl) return;
    var C = {};
    try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var T = C.textes || {};
    if (T.parler_tel) T.parler_tel = T.parler_tel.replace("{tel}", C.telephone || "");
    var mode = racine.getAttribute("data-rogc") || "page";
    var fr = String(C.langue || "fr").slice(0, 2) === "fr";
    var CLE = "rogConseiller:" + mode + ":" + (C.racine || "/") + (mode === "fiche" ? ":" + (C.fiche && C.fiche.handle) : "");
    var etat = { fil: [], fiche: C.fiche || null, envoi: false, humain: "ferme" };
    try { var s = JSON.parse(sessionStorage.getItem(CLE) || "null"); if (s && Array.isArray(s.fil)) { etat.fil = s.fil.filter(function (e) { return !e.attente; }).slice(-12); if (mode === "page" && s.fiche !== undefined) etat.fiche = s.fiche; if (s.humain === "envoye") etat.humain = "envoye"; } } catch (e) {}

    var $ = function (sel) { return racine.querySelector(sel); };
    racine.querySelectorAll("[data-t]").forEach(function (el) { el.textContent = T[el.getAttribute("data-t")] || ""; });
    racine.querySelectorAll("[data-t-placeholder]").forEach(function (el) { el.placeholder = T[el.getAttribute("data-t-placeholder")] || ""; });
    var form = $(".rogc__form"), champ = $(".rogc__champ"), bouton = $(".rogc__envoyer"), compteur = $(".rogc__compteur"), fil = $(".rogc__fil"), puce = $(".rogc__puce");

    function sauver() { try { sessionStorage.setItem(CLE, JSON.stringify({ fil: etat.fil.filter(function (e) { return !e.attente; }).slice(-12), fiche: etat.fiche, humain: etat.humain === "envoye" ? "envoye" : undefined })); } catch (e) {} }

    // ---- Parler à un conseiller (fiche seulement, 22/10/2026) : bouton après la première réponse, formulaire dans le bloc ----
    var humain = null;
    if (mode === "fiche" && T.h_bouton) {
      humain = document.createElement("div");
      humain.className = "rogc__humain";
      humain.hidden = true;
      fil.parentNode.insertBefore(humain, fil.nextSibling);
    }
    function formHumain() {
      return '<form class="rogc__humain-form" novalidate><h3>' + esc(T.h_titre) + "</h3><p>" + esc(T.h_texte) + "</p>" +
        '<label class="visually-hidden" for="rogc-h-message">' + esc(T.h_placeholder) + "</label>" +
        '<textarea class="rogc__h-message" id="rogc-h-message" name="message" rows="3" maxlength="1000" placeholder="' + esc(T.h_placeholder) + '"></textarea>' +
        '<label class="visually-hidden" for="rogc-h-email">' + esc(T.champ_email) + "</label>" +
        '<input class="rogc__input" id="rogc-h-email" name="contact" type="email" autocomplete="email" inputmode="email" placeholder="' + esc(T.champ_email) + '">' +
        '<label class="rogc__consent"><input type="checkbox" name="consentement"><span>' + esc(T.consentement) + "</span></label>" +
        '<div class="rogc__h-actions"><button class="rogc__envoyer" type="submit">' + esc(T.h_envoyer) + '</button><button class="rogc__h-annuler" type="button">' + esc(T.h_annuler) + "</button></div>" +
        '<p class="rogc__erreur" role="alert" hidden></p></form>';
    }
    function rendreHumain() {
      if (!humain) return;
      var repondu = etat.fil.some(function (e) { return !e.attente && e.reponse; });
      // le conseiller automatique a déjà affiché son propre formulaire de rappel : pas de second formulaire à côté
      var rappelAffiche = etat.fil.some(function (e) { return e.rappel && !e.rappelFait; });
      humain.hidden = !repondu || (rappelAffiche && etat.humain === "ferme");
      if (humain.hidden) return;
      if (etat.humain === "envoye") { humain.innerHTML = '<p class="rogc__ok" role="status">' + esc(T.h_ok) + "</p>"; return; }
      if (etat.humain === "ouvert") { if (!humain.querySelector("form")) humain.innerHTML = formHumain(); return; }
      if (!humain.querySelector(".rogc__humain-ouvrir")) humain.innerHTML = '<button class="rogc__humain-ouvrir" type="button" aria-expanded="false">' + esc(T.h_bouton) + "</button>";
    }
    if (humain) {
      humain.addEventListener("click", function (ev) {
        if (ev.target.closest(".rogc__humain-ouvrir")) {
          etat.humain = "ouvert"; rendreHumain();
          var t = humain.querySelector(".rogc__h-message");
          if (humain.getBoundingClientRect().bottom > window.innerHeight) humain.scrollIntoView({ behavior: "smooth", block: "center" });
          if (t) setTimeout(function () { t.focus({ preventScroll: true }); }, 60);
          return;
        }
        if (ev.target.closest(".rogc__h-annuler")) {
          etat.humain = "ferme"; humain.innerHTML = ""; rendreHumain();
          var b = humain.querySelector(".rogc__humain-ouvrir"); if (b) b.focus({ preventScroll: true });
        }
      });
      humain.addEventListener("submit", function (ev) {
        var f = ev.target.closest(".rogc__humain-form"); if (!f) return;
        ev.preventDefault();
        var err = f.querySelector(".rogc__erreur"), envoi = f.querySelector("button[type=submit]");
        var message = f.querySelector('[name="message"]').value.trim().slice(0, 1000), contact = f.querySelector('[name="contact"]').value.trim();
        var dernier = etat.fil.filter(function (e) { return !e.attente && e.reponse; }).pop() || {};
        var fiches = [];
        etat.fil.forEach(function (e) { (e.fiches || []).forEach(function (x) { if (x && x.handle && fiches.indexOf(x.handle) < 0) fiches.push(x.handle); }); });
        var corps = { type: "conseiller", canal: "email", contact: contact, message: message, consentement: f.querySelector('[name="consentement"]').checked,
          langue: C.langue, question: dernier.question || "", reponse: String(dernier.reponse || "").slice(0, 1500), fiches: fiches.slice(0, 3),
          page: etat.fiche ? etat.fiche.handle : "", adresse: location.origin + location.pathname, configuration: lireConfiguration(),
          motif: "Parler à un conseiller (bloc question de la fiche)" };
        if (message.length < 2 || !corps.consentement || !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(contact)) { err.hidden = false; err.textContent = T.rappel_erreur; return; }
        err.hidden = true; envoi.disabled = true;
        // MODE DÉMONSTRATION : rien n'est envoyé, la confirmation est simulée.
        var p = C.demo ? new Promise(function (r) { setTimeout(function () { r({ ok: true }); }, 700); })
          : fetch(C.adresse + "/rappel", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(corps) }).then(function (r) { return r.json(); });
        p.then(function (d) { if (!d || !d.ok) throw new Error(d && d.erreur); etat.humain = "envoye"; sauver(); humain.innerHTML = ""; rendreHumain(); })
          .catch(function () { err.hidden = false; err.textContent = T.rappel_erreur; envoi.disabled = false; });
      });
    }

    function carteFiche(f) {
      var img = f.image ? f.image + (f.image.indexOf("?") > -1 ? "&" : "?") + "width=240" : "";
      return '<a class="rogc__fiche" href="' + esc(f.url) + '">' +
        '<span class="rogc__fiche-img" style="background-image:url(\'' + esc(img.replace(/'/g, "")) + '\')"></span>' +
        '<span><span class="rogc__fiche-titre">' + esc(f.titre) + "</span>" +
        (f.prix ? '<span class="rogc__fiche-prix">' + esc(T.a_partir_de) + " " + esc(f.prix) + "</span>" : "") +
        '<span class="rogc__fiche-cta">' + esc(T.ouvrir) + "</span></span></a>";
    }

    function blocRappel(i) {
      var canaux = fr ? ["telephone", "email"] : ["email"];
      var seg = canaux.length > 1 ? '<div class="rogc__segment" role="group">' + canaux.map(function (c, k) {
        return '<button type="button" data-canal="' + c + '" aria-pressed="' + (k === 0) + '">' + esc(c === "telephone" ? T.telephone : T.email) + "</button>";
      }).join("") + "</div>" : "";
      return '<form class="rogc__rappel" data-i="' + i + '" novalidate><h3>' + esc(T.rappel_titre) + "</h3><p>" + esc(T.rappel_texte) + "</p>" + seg +
        '<input class="rogc__input" name="contact" autocomplete="' + (canaux[0] === "telephone" ? "tel" : "email") + '" inputmode="' + (canaux[0] === "telephone" ? "tel" : "email") +
        '" placeholder="' + esc(canaux[0] === "telephone" ? T.champ_tel : T.champ_email) + '" data-canal="' + canaux[0] + '">' +
        '<input class="rogc__input" name="message" maxlength="600" placeholder="' + esc(T.precision) + '">' +
        '<label class="rogc__consent"><input type="checkbox" name="consentement"><span>' + esc(T.consentement) + "</span></label>" +
        '<button class="rogc__envoyer" type="submit">' + esc(T.rappel_envoyer) + '</button><p class="rogc__erreur" hidden></p></form>';
    }

    function rendreFil() {
      fil.innerHTML = etat.fil.map(function (e, i) {
        var corps = e.attente
          ? '<div class="rogc__attente" role="status"><span class="rogc__points"><i></i><i></i><i></i></span>' + esc(T.en_cours) + "</div>"
          : '<div class="rogc__r' + (e.neuf ? " rogc__r--neuf" : "") + '">' + rendre(e.reponse) + "</div>" +
            (e.fiches && e.fiches.length ? '<div class="rogc__fiches">' + e.fiches.map(carteFiche).join("") + "</div>" : "") +
            (e.rappel && !e.rappelFait ? blocRappel(i) : "") +
            (e.rappelFait ? '<div class="rogc__rappel"><p class="rogc__ok">' + esc(T.rappel_ok) + "</p></div>" : "") +
            (!e.avis ? '<div class="rogc__avis">' + esc(T.utile) + ' <button type="button" data-avis="1" data-i="' + i + '">' + esc(T.oui) + '</button><button type="button" data-avis="0" data-i="' + i + '">' + esc(T.non) + "</button></div>" : '<div class="rogc__avis">' + esc(T.merci) + "</div>");
        return '<article class="rogc__echange' + (e.attente ? " rogc__echange--neuf" : "") + '"><p class="rogc__q-label">' + esc(T.vous) + '</p><p class="rogc__q">' + esc(e.question).replace(/ ([?!:;])/g, "\u00a0$1") + "</p>" + corps + "</article>";
      }).join("");
      etat.fil.forEach(function (e) { e.neuf = false; });
      var n = $(".rogc__nouvelle");
      if (n) n.hidden = !etat.fil.length;
      rendreHumain();
    }

    function rendrePuce() {
      if (!puce) return;
      if (mode === "page" && etat.fiche && etat.fiche.titre) {
        puce.hidden = false;
        puce.querySelector("span").innerHTML = "<b>" + esc(T.a_propos) + "</b> " + esc(etat.fiche.titre);
      } else puce.hidden = true;
    }

    function majBouton() {
      var n = champ.value.trim().length;
      bouton.disabled = etat.envoi || n < 2;
      if (compteur) compteur.textContent = n > 600 ? n + " / 800" : "";
    }

    function poser(corps) {
      if (C.demo && window.RogConseillerDemo) return window.RogConseillerDemo.repondre(corps, C); // MODE DÉMONSTRATION (aperçu seulement)
      return fetch(C.adresse + "/question", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(corps) })
        .then(function (r) { return r.json().catch(function () { return {}; }); });
    }

    function envoyer(question) {
      etat.envoi = true; majBouton();
      var historique = [];
      etat.fil.forEach(function (e) { if (!e.attente && e.reponse) { historique.push({ role: "user", texte: e.question }); historique.push({ role: "assistant", texte: e.reponse }); } });
      var e = { question: question, attente: true };
      etat.fil.push(e); rendreFil();
      var dernier = fil.lastElementChild;
      if (dernier && dernier.getBoundingClientRect().top > window.innerHeight * 0.75) dernier.scrollIntoView({ behavior: "smooth", block: "center" });
      var page = { langue: C.langue, racine: C.racine, devise: C.devise, handle: etat.fiche ? etat.fiche.handle : "" };
      if (mode === "fiche") page.configuration = lireConfiguration();
      poser({ question: question, historique: historique.slice(-8), page: page }).then(function (d) {
        e.reponse = d.reponse || T.erreur;
        e.fiches = d.fiches || [];
        e.rappel = d.rappel || (d.reponse ? null : true);
        e.id = d.id || null; e.demo = !!d.demo;
      }).catch(function () {
        e.reponse = T.erreur; e.rappel = true;
      }).then(function () {
        e.attente = false; e.neuf = true;
        etat.envoi = false; sauver(); rendreFil(); majBouton();
      });
    }

    form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var q = champ.value.trim().slice(0, 800);
      if (q.length < 2 || etat.envoi) return;
      champ.value = ""; champ.style.height = "";
      envoyer(q);
    });
    champ.addEventListener("keydown", function (ev) {
      if (ev.key === "Enter" && !ev.shiftKey && !ev.isComposing) { ev.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true })); }
    });
    champ.addEventListener("input", function () { champ.style.height = "auto"; champ.style.height = Math.min(champ.scrollHeight, 320) + "px"; majBouton(); });
    if (puce) puce.querySelector("button").addEventListener("click", function () { etat.fiche = null; sauver(); rendrePuce(); champ.focus(); });

    fil.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-avis]");
      if (b) {
        var e = etat.fil[+b.dataset.i]; if (!e) return;
        e.avis = b.dataset.avis === "1" ? 1 : -1; sauver(); rendreFil();
        if (!C.demo && e.id) fetch(C.adresse + "/avis", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: e.id, utile: e.avis === 1 }) }).catch(function () {});
        return;
      }
      var s = ev.target.closest(".rogc__segment button");
      if (s) {
        var f = s.closest("form"), inp = f.querySelector('[name="contact"]'), c = s.dataset.canal;
        f.querySelectorAll(".rogc__segment button").forEach(function (x) { x.setAttribute("aria-pressed", x === s); });
        inp.dataset.canal = c; inp.placeholder = c === "telephone" ? T.champ_tel : T.champ_email;
        inp.inputMode = c === "telephone" ? "tel" : "email"; inp.autocomplete = c === "telephone" ? "tel" : "email"; inp.value = ""; inp.focus();
      }
    });
    fil.addEventListener("submit", function (ev) {
      var f = ev.target.closest(".rogc__rappel"); if (!f) return;
      ev.preventDefault();
      var i = +f.dataset.i, e = etat.fil[i], inp = f.querySelector('[name="contact"]'), err = f.querySelector(".rogc__erreur");
      var corps = { canal: inp.dataset.canal, contact: inp.value.trim(), message: f.querySelector('[name="message"]').value.trim(),
        consentement: f.querySelector('[name="consentement"]').checked, langue: C.langue, question: e.question,
        fiches: (e.fiches || []).map(function (x) { return x.handle; }), page: etat.fiche ? etat.fiche.handle : "" };
      var ok = corps.consentement && (corps.canal === "email" ? /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(corps.contact) : corps.contact.replace(/\D/g, "").length >= 9);
      if (!ok) { err.hidden = false; err.textContent = T.rappel_erreur; return; }
      f.querySelector("button[type=submit]").disabled = true;
      // MODE DÉMONSTRATION : rien n'est envoyé, la confirmation est simulée.
      var envoi = C.demo ? new Promise(function (r) { setTimeout(function () { r({ ok: true }); }, 700); })
        : fetch(C.adresse + "/rappel", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(corps) }).then(function (r) { return r.json(); });
      envoi.then(function (d) { if (!d.ok) throw new Error(d.erreur); e.rappelFait = true; sauver(); rendreFil(); })
        .catch(function () { err.hidden = false; err.textContent = T.rappel_erreur; f.querySelector("button[type=submit]").disabled = false; });
    });
    var nouvelle = $(".rogc__nouvelle");
    if (nouvelle) nouvelle.addEventListener("click", function () { etat.fil = []; sauver(); rendreFil(); champ.focus(); });

    if (mode === "page") {
      var demandee = new URLSearchParams(location.search).get("fiche");
      if (demandee && /^[a-z0-9-]{3,120}$/.test(demandee)) {
        fetch((C.racine || "") + "/products/" + demandee + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (p) { etat.fiche = { handle: demandee, titre: p.title }; sauver(); rendrePuce(); }
        }).catch(function () {});
      }
    }
    rendrePuce(); rendreFil(); majBouton();
  }

  function tout() { document.querySelectorAll("[data-rogc]").forEach(function (r) { if (!r.dataset.rogcPret) { r.dataset.rogcPret = "1"; demarrer(r); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tout); else tout();

  // La ligne « Une question ? » de la réassurance (et tout lien vers #rog-question) amène au bloc et ouvre le champ.
  document.addEventListener("click", function (ev) {
    var a = ev.target.closest('a[href$="#rog-question"]');
    var bloc = document.getElementById("rog-question");
    if (!a || !bloc) return;
    ev.preventDefault();
    var c = bloc.querySelector(".rogc__champ");
    (bloc.querySelector(".rogc__form") || bloc).scrollIntoView({ behavior: "smooth", block: "center" });
    if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 450);
  });
})();
